import {EventBroker} from "@frontend/lib/utils/event-broker";

export const IDML_LAYERS_EVENTS = {
  INIT: 'INIT',
  IDML_FILE_PARSED: 'IDML_FILE_PARSED',
};

export const IDML_LAYERS_FLOWS = {
  PREVIEW: 'PREVIEW',
  CREATE_TEMPLATES: 'CREATE_TEMPLATES',
};

export const idmlLayersEventBroker = new EventBroker();
